import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-primary group-[.toaster]:text-primary-foreground group-[.toaster]:border-primary group-[.toaster]:shadow-xl group-[.toaster]:rounded-xl group-[.toaster]:px-6 group-[.toaster]:py-4 group-[.toaster]:text-base group-[.toaster]:min-w-[320px]",
          description: "group-[.toast]:text-primary-foreground/80 group-[.toast]:text-sm",
          actionButton: "group-[.toast]:bg-white group-[.toast]:text-primary",
          cancelButton: "group-[.toast]:bg-white/20 group-[.toast]:text-primary-foreground",
          success: "group-[.toaster]:bg-primary group-[.toaster]:border-primary [&_svg]:text-primary-foreground",
          error: "group-[.toaster]:bg-destructive group-[.toaster]:border-destructive group-[.toaster]:text-destructive-foreground [&_svg]:text-destructive-foreground",
          icon: "group-[.toast]:text-primary-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
